export enum GameMode {
    singeli = 'singeli',
    dubbeli = 'dubbeli',
    trippeli = 'trippeli',
    sekaDubbeli = 'sekaDubbeli'
}